<template>
  <div class="group-input col-12 row q-mt-lg">
   <label class="col-12">{{title}}</label>
   <div class="col-12 row justify-center">
     <div class="col-7 q-mt-sm position-item" >
       <q-radio
         v-for="option in options" :key="option"
         v-model="selected"
         @click="$emit('selectedOption', selected), showAlert && messageAlert(option.MessageAlert)"
         keep-color
         :disable="disabledOption.isDisabled && option.value == disabledOption.label"
         :val="option.value"
         :label="option.label"
         color="red-9"
         type="radio"
         :class="options.length === 1 && 'col-12'"
         />
     </div>
   </div>
 </div>
</template>

<script setup>
import { useQuasar } from "quasar";
import { ref } from 'vue';

const $q = useQuasar()
const emit = defineEmits(["selectedOption"])
const props = defineProps({
 title: String,
 selection: String,
 options: Array,
 showAlert: {
   type: Boolean,
   default: false,
 },
 disabledOption: {
   type: Boolean,
   default: true,
 }
})

let selected = ref(props.selection)

function messageAlert(value) {
 $q.notify({
   message: value,
   color: "yellow-9",
   position: "top",
   timeout: 3000,
 });
}

</script>

<style scoped>
.position-items{
 width: 100%;
}
.position-item{
 display: flex;
 justify-content: space-between;
}

label {
 font-weight: bold;
 font-size: 14px;
 color: rgba(0, 0, 0, 0.4);
}
</style>